var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 22,
    fill: "url(#pattern53)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern53",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4106_9079",
    transform: "translate(0 -0.00699301) scale(0.025641 0.0337995)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4106_9079",
    width: 39,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAeCAYAAACv1gdQAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJ6ADAAQAAAABAAAAHgAAAACSBRhfAAABu0lEQVRYCc2W603DQBCEw+M/pgIrNECoANGBU0EQJVAAjw6gAEjSCHEqSKgApYKEAlCYsbxmOcnIe14LrzS5s707990jcQaDn8jQXUBbaG8Q80dQZzGFswUozO0MkCsWDhZz3QlgruBm6A+hw4a6QN4Oksm4Ah7AmIYJxDiDNkWv+cc5UhfQSVlC2Keyb2lYt4aWukhmzbbpioV54QpqT2t/BY6RAOricFDLtSfgB+ASbivhJI6kE9lyi7PI2rSsleMxp4/XyllWuS53rHhW3ivHybaNLzHgDHobHnByRtwn6QHHr/2LOxkMPeDIdQ3ds+MZXnBkuoMmfYUj16sn4HHNTC9xn2oSaZBEQL4j34P7UZd7VIm4zdSjuifPLO0W9XydiZ+lrcZhUReRwPQNStuYdwVHpg206yPcJ6D4nmQbHXVfiNzgyK2bqHwCXUFcudZRHUA4WQ6u5BJEe/BansW0lReLPeMGZksvQ0+4W0DNvcDoQzh9aNNIc0I9R9bqMj1+wZXjqezzFP0hROimOjXk/uXJcTm+sOToF//55Uaf2oxwjBnUJ7AH8PwKkuYQf9X/A5Tjcvxqxb4BnmkdlbnfA/IAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveItem);
export default __webpack_public_path__ + "static/media/move-item.878c3626517eb12a164754c0eaafc31c.svg";
export { ForwardRef as ReactComponent };